<template>
  <section class="project-detail">
    <div class="container">
      <!-- Lower Content -->
      <div class="lower-content">
        <div class="row">
          <div class="text-column col-lg-8 col-md-12 col-sm-12">
            <div class="upper-box">
              <div class="single-item-carousel owl-carousel owl-theme">
                <figure class="image">
                  <img src="../assets/img/class/shivani-background.png" alt="" />
                </figure>
              </div>
            </div>
            <div class="col-lg-12 mobile-only">
              <aside class="sidebar-widget info-column">
                <div class="inner-column3">
                  <h3>Course Details</h3>
                  <ul class="project-info clearfix">
                    <li>
                      <div class="priceing">
                        <strong>Call for pricing</strong>
                        <!-- <strong>$00.00</strong> <sub>$500.00</sub>
                          <span class="discont">100% OFF</span> -->
                      </div>
                    </li>
                    <li>
                      <span class="icon fal fa-home-lg-alt"></span>
                      <strong>Instructor:</strong> <span>Shivani Bagga</span>
                    </li>

                    <li>
                      <span class="icon fal fa-book"></span>
                      <strong>Lectures:</strong> <span>12</span>
                    </li>

                    <li>
                      <span class="icon fal fa-clock"></span>
                      <strong>Duration: </strong> <span>12 weeks</span>
                    </li>
                    <li>
                      <span class="icon fal fa-user"></span>
                      <strong>Capacity: </strong> <span>20 students</span>
                    </li>
                    <li>
                      <span class="icon fal fa-globe"></span>
                      <strong>Language: </strong> <span>English</span>
                    </li>
                    <li>
                      <div class="slider-btn">
                        <a href="/login" class="btn ss-btn smoth-scroll"
                          >Enroll (coming soon) <i class="fal fa-long-arrow-right"></i
                        ></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
            <div class="inner-column">
              <div class="course-meta2 review style2 clearfix mb-30">
                <ul class="left">
                  <li>
                    <div class="author">
                      <div class="thumb">
                        <img src="../assets/img/bg/shivani-bagga-portrait.webp" alt="image" />
                      </div>

                      <div class="text text-left">
                        <a>Shivani Bagga</a>
                        <p>Teacher</p>
                      </div>
                    </div>
                  </li>
                  <li class="categories text-left">
                    <div class="author">
                      <div class="text">
                        <a href="#" class="course-name">Real Estate</a>
                        <p>Category</p>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul class="right">
                  <li class="price">Call for pricing</li>
                </ul>
              </div>

              <div style="text-align: left">
                <h3>Financial Literacy</h3>
              </div>

              <h3 style="text-align: left; margin-top: 2rem">Meet your facilitators</h3>

              <div class="row course-details-teachers-main">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="class-item mb-30">
                    <!-- class-img -->
                    <div class="class-img">
                      <div class="class-img-outer">
                        <a> <img src="../assets/img/bg/shivani-bagga-portrait.webp" alt="class image" /></a>
                      </div>
                    </div>
                    <!-- class-img -->
                    <!-- schedule -->

                    <!-- schedule-end -->
                    <!-- class-content -->
                    <div class="class-content" style="text-align: left">
                      <h4 class="title"><a>Shivani Bagga</a></h4>
                      <p></p>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <!-- class-content-end -->
                  </div>
                </div>
              </div>

              <h3 style="text-align: left; margin-top: 2rem">Course Content</h3>
              <p style="text-align: left">1 Lecture. 3 hrs</p>
              <div class="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                <div id="accordionExample" class="accordion">
                  <div class="card">
                    <div id="headingThree" class="card-header">
                      <h2 class="mb-0">
                        <button class="faq-btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                          Topics we will cover
                          <span>1 Lecture. 3 hrs</span>
                        </button>
                      </h2>
                    </div>
                    <div id="collapseThree" class="collapse show" data-bs-parent="#accordionExample">
                      <div class="card-body">
                        <div class="leactures" style="text-align: left"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 desktop-only">
            <aside class="sidebar-widget info-column">
              <div class="inner-column3">
                <h3>Course Details</h3>
                <ul class="project-info clearfix">
                  <li>
                    <div class="priceing">
                      <strong>Call for pricing</strong>
                      <!-- <strong>$00.00</strong> <sub>$500.00</sub>
                        <span class="discont">100% OFF</span> -->
                    </div>
                  </li>
                  <li>
                    <span class="icon fal fa-home-lg-alt"></span>
                    <strong>Instructor:</strong> <span>Shivani Bagga</span>
                  </li>

                  <li>
                    <span class="icon fal fa-book"></span>
                    <strong>Lectures:</strong> <span></span>
                  </li>

                  <li>
                    <span class="icon fal fa-clock"></span>
                    <strong>Duration: </strong> <span>3 hrs</span>
                  </li>
                  <li>
                    <span class="icon fal fa-user"></span>
                    <strong>Capacity: </strong> <span></span>
                  </li>
                  <li>
                    <span class="icon fal fa-globe"></span>
                    <strong>Language: </strong> <span>English</span>
                  </li>
                  <li>
                    <span class="icon fal fa-coins"></span>
                    <strong>Financing: </strong> <span>Available</span>
                  </li>
                  <li>
                    <div class="slider-btn">
                      <a href="/login" class="btn ss-btn smoth-scroll"
                        >Enroll (coming soon) <i class="fal fa-long-arrow-right"></i
                      ></a>
                    </div>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      courses: [
        {
          title: 'Vue.js for Beginners',
          instructor: 'John Doe',
          description: 'Learn the fundamentals of Vue.js and build amazing web applications.',
          price: 49.99,
          duration: 10,
          slug: 'the-lighthouse-leadership-program',
        },
      ],
      course: null,
    };
  },
  mounted() {
    const courseName = this.$route.params.courseName;
    this.course = this.courses.find((course) => course.slug === courseName);
  },
  methods: {
    enroll() {
      alert(`You have enrolled in ${this.course.title}`);
    },
  },
};
</script>

<style scoped>
.course-details {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}

button {
  background-color: #42b983;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #36976f;
}

.course-details-teachers-main .class-img {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 350px; /* Adjust height as needed */
}

.course-details-teachers-main .class-img img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures images fill the container without stretching */
  border-radius: 10px; /* Optional: adds rounded corners */
}
</style>
